<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <!-- v-if="editedItem.imagen != '' -->
        <base-material-card color="blue">
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              Editar Perfil
              <span class="body-1">— Complete su Perfil</span>
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                 <v-col cols="8">
                  <!-- <v-text-field v-model="editedItem.genero" label="Genero" class="purple-input" /> -->
                  <v-select
                    v-model="usuarios[0].id_entidad"
                    :items="entidades"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Entidad"
                    item-text="ent_nombre"
                    item-value="id_entidad"
                    persistent-hint
                    dense
                    disabled
                  ></v-select>
                  <!-- {{ editedItem.genero }} -->
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    required
                    v-model="usuarios[0].usr_login"
                    label="usuario"
                    class="purple-input"
                    dense
                    disabled
                  />
                  </v-col>
                <v-col cols="12">
                  <v-text-field
                    required
                    v-model="usuarios[0].usr_nombre"
                    label="Nombre(s)"
                    class="purple-input"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="usuarios[0].usr_correo"
                    label="Correo Electrónico"
                    class="purple-input"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="usuarios[0].usr_telefono"
                    label="Teléfono"
                    class="purple-input"
                  />
                </v-col>
               

               

                <v-col cols="12" class="text-right">
                  <v-btn color="blue darken-1" text @click="saveForm">Actualizar Perfil</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getValidToken } from '@/store/helpers.js'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
//import ThumborImage from '@/components/general/ThumborImage.vue'
//import axios from 'axios'
//const baseURL = process.env.VUE_APP_BASE_URL_API

export default {
  components: {
    
  },
  data: () => ({
    isLoading: false,
    usuario: JSON.parse(localStorage.getItem('user')),
    usuarios: [],
    entidades: [],
    editedIndex: 0,
    dialog: false,
    img: '',
    mixins: [validationMixin],
    validations: {
      editedItem: {
        usr_nombre: { required, minLength: minLength(3), maxLength: maxLength(20) },
      },
    },
    reglasAvatar: [
      (value) => !value || value.size < 10000000 || 'El tamaño del avatar debe ser menor a 4MB !!',
    ],
  }),
  created() {
    //this.obtenerGeneros()
    //this.obtenerUsuario()
    this.iniciando()
  },
  methods: {
    async iniciando() {
      let jwt = await getValidToken(this)
      this.obtenerEntidades(jwt)
      this.obtenerUsuario(jwt)
      //this.obtenerFiles(jwt, 1)
    },
    //Obtiene todos las ENTIDADES para el select
    async obtenerEntidades(jwt) {
      this.isLoading = true
      let params = null
      if (jwt != null) {
        let payload = { jwt: jwt, params: params }
        this.$store
          .dispatch('entidad/fetchEntidad', payload)
          .then((response) => {
            this.entidades = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    // Obtener todos los Usuarios
    async obtenerUsuario() {
      this.isLoading = true
      let jwt = await getValidToken(this)
      let payload = {
        jwt: jwt,
        id: this.usuario.id_usr,
      }
      if (jwt !== null) {
        this.$store
          .dispatch('user/fetchUsersId', payload)
          .then((response) => {
            this.usuarios = response.data
            this.editedItem = response.data
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    // Guardar Formulario
    async saveForm() {
      //this.$v.$touch()
      //if (!this.$v.$invalid) {
      let body = {
        usr_nombre: this.usuarios[0].usr_nombre,
        usr_correo: this.usuarios[0].usr_correo,
        usr_telefono: this.usuarios[0].usr_telefono,
        usr_rol: this.usuarios[0].usr_rol,
        usr_activo: this.usuarios[0].usr_activo,
        id_entidad: this.usuarios[0].id_entidad,
      }
      
      if (this.editedIndex == 0) {
        // Edita formulario
        let id = this.usuarios[0].id_usr
        let jwt = await getValidToken(this)
        let payload = { jwt: jwt, id: id, body: body }
        this.$store
          .dispatch('user/editUser', payload)
          .then(() => {
            this.$store.commit('ALERT', {
              color: 'success',
              text: 'El registro fue actualizado con éxito',
            })
          })
          .catch((err) => {
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.msg,
            })
          })
        //Object.assign(this.usuarios[this.editedIndex], this.editedItem)
        //}
        //this.closeForm()
      }
    },
  },
  computed: {
    NombreErrors() {
      const errors = []
      if (!this.$v.editedItem.usr_nombre.$dirty) return errors
      !this.$v.editedItem.usr_nombre.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.usr_nombre.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.usr_nombre.maxLength &&
        errors.push('Este campo debe de tener un máximo de 20 caracteres.')
      return errors
    },
  },
}
</script>
